import(/* webpackMode: "eager", webpackExports: ["ForgetPasswordForm"] */ "/app/src/app/(auth)/forget-password/forget-password-form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ui/transition.tsx");
